// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LIysyddUbvKw75Tw3wpDN","visible":"_2tmlfYgmNTdS2yg2lDhY6w","cancelBtn":"gHtmAKdw1gWfh0IL0wp-w","icon":"_3vr-r6ClhqubOhS2olcKNI","saveBtn":"_3VZuIzM0RQBFMttpX1HBvj"};